import angular from 'angular'

const TARGET_RESET_PASSWORD = 'account/ValidateResetPassword/'
const TARGET_VALIDATE_EMAIL = 'account/ValidateMail/'

let module = angular.module('emailLinkRedirect', [])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('standaloneRedirections', {
      url: '/:country/home?target&locale',
      redirectTo: (trans) => {
        let target = trans.params().target
        let locale
        const I18n = trans.injector().get('I18n')
        // Reset password confirmation
        if (target && target.startsWith(TARGET_RESET_PASSWORD)) {
          target = target.replace(TARGET_RESET_PASSWORD, '')
          if (target.includes('?locale=')) {
            locale = target.split('?locale=')[1]
            target = target.split('?')[0]
          }
          if (target) {
            const params = target.split('/')
            if (params && params.length === 2) {
              const email = params[0]
              const token = params[1]
              if (email && token) {
                if (locale) {
                  return I18n.changeLanguage(locale).then(() => {
                    return {state: 'authentication', params: {email, token}}
                  })
                } else {
                  return {state: 'authentication', params: {email, token}}
                }
              }
            }
          }
        // Registration confirmation
        } else if (target && target.startsWith(TARGET_VALIDATE_EMAIL)) {
          target = target.replace(TARGET_VALIDATE_EMAIL, '')
          if (target.includes('?locale=')) {
            locale = target.split('?locale=')[1]
            target = target.split('?')[0]
          }
          if (target) {
            const params = target.split('/')
            if (params && params.length === 3) {
              const email = params[0]
              const token = params[1]
              const huType = params[2]
              if (email && token && huType) {
                if (locale) {
                  return I18n.changeLanguage(locale).then(() => {
                    return {state: 'authentication', params: {email, token, huType}}
                  })
                } else {
                  return {state: 'authentication', params: {email, token, huType}}
                }
              }
            }
          }
        }
        return 'home'
      }
    })

    .state('validateMailRSiteRedirectionWithLocale', {
      url: '/{country}/' + TARGET_VALIDATE_EMAIL + ':email/:token/:huType',
      redirectTo: (trans) => {
        const { country, email, token, huType } = trans.params()
        if (email && token && huType) {
          const I18n = trans.injector().get('I18n')
          return I18n.changeLanguage(country).then(() => {
            return {state: 'authentication', params: {email, token, huType}}
          })
        }
        return 'home'
      }
    })

    .state('validateMailRSiteRedirection', {
      url: '/' + TARGET_VALIDATE_EMAIL + ':email/:token/:huType',
      redirectTo: (trans) => {
        const { email, token, huType } = trans.params()
        if (email && token && huType) {
          return {state: 'authentication', params: { email, token, huType }}
        }
        return 'home'
      }
    })

    .state('validateResetPasswordRSiteRedirectionWithLocale', {
      url: '/{country}/' + TARGET_RESET_PASSWORD + ':email/:token',
      redirectTo: (trans) => {
        const { country, email, token } = trans.params()
        if (email && token) {
          const I18n = trans.injector().get('I18n')
          return I18n.changeLanguage(country).then(() => {
            return {state: 'authentication', params: {email, token}}
          })
        }
        return 'home'
      }
    })

    .state('validateResetPasswordRSiteRedirection', {
      url: '/' + TARGET_RESET_PASSWORD + ':email/:token',
      redirectTo: (trans) => {
        const { email, token } = trans.params()
        if (email && token) {
          return {state: 'authentication', params: { email, token }}
        }
        return 'home'
      }
    })
})
.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/email-link-redirect/index.js